
<section class="relatedShops">
  <div class="relatedShops__container">
    <h2 class="shopCommonInfo__title">同じエリアのお店</h2>
    <div class="ui five cards pcOnly">
      <a class="ui card" v-for="shop in shops" :key="shop.id" :href="shop.detail_url" target="_blank">
        <div class="image">
          <img :src="shop.main_image.urls.medium_square" :alt="shop.name + '+宴会パーティ'">
        </div>
        <div class="content">
          <div class="header">{{ shop.name }}</div>
          <div class="description">
            <span v-for="genre in shop.genre_labels">{{ genre.label }}</span>
          </div>
          <div class="extra">
            <div v-if="shop.max_standing_count || shop.max_count">立席：{{ shop.max_standing_count || '--' }}人 着席：{{ shop.max_count || '--' }}人 まで</div>
            <div v-if="shop.lowest_price">{{ shop.lowest_price }}円〜</div>
          </div>
        </div>
      </a>
    </div>
    <div class="spOnly" style="text-align: center;">
      <a class="ui card" v-for="shop in spShops" :key="shop.id" :href="shop.detail_url" target="_blank">
        <div class="image">
          <img :src="shop.main_image.urls.medium_square" :alt="shop.name + '+宴会パーティ'">
        </div>
        <div class="content">
          <div class="header">{{ shop.name }}</div>
          <div class="description">
              <span v-for="genre in shop.genre_labels">{{ genre.label }}</span>
          </div>
          <div class="extra">
            <div v-if="shop.max_standing_count || shop.max_count">立席：{{ shop.max_standing_count || '--' }}人 着席：{{ shop.max_count || '--' }}人 まで</div>
            <div v-if="shop.lowest_price">{{ shop.lowest_price }}円〜</div>
          </div>
        </div>
      </a>
    </div>
    <div class="relatedShops__more">
      <a :href="`/shops/search?prefecture=${prefecture}&area=${area}`" class="shopInStore__link">
        <i class="fas fa-angle-right"></i> もっと見る
      </a>
    </div>
  </div>
</section>
